import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Router} from '@angular/router';

@Component({
    selector: 'app-deployment-summary',
    templateUrl: './deployment-summary.component.html',
    styleUrls: ['./deployment-summary.component.scss']
})
export class DeploymentSummaryComponent implements OnInit {

    sourceDatabase: any;
    deploymentPlanMenu: any;
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DeploymentSummaryComponent>, public router: Router) {
    }

    ngOnInit() {
        // console.log(this.data);
        if (this.data && this.data.sourceDatabase && this.data.status) {
            this.sourceDatabase = this.data.sourceDatabase;
            if (this.data.status[0] && this.data.status[0].submenu && this.data.status[0].submenu.length) {
                this.deploymentPlanMenu = this.data.status[0].submenu;
            }
        }
    }

    APIDocumentation(api) {
        this.dialogRef.close();
        // if (this.apiType === 'DATAACCESS') {
        this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account + '&entity=' + api.name + '&version=' + api.version + '&showDoc=true');
        // } else {
        //     this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account + '&executor_name=' + this.entityName + '&executor_version=' + this.version + '&showDoc=true');
        // }
    }

    closeDialog() {
        this.dialogRef.close();
    }

}
